import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { EquityPageComponentModel } from '../../models/equity-page-component.model';
import { EquityTileItemComponent } from './parts/equity-tile-item/equity-tile-item.component';

@Component({
  selector: 'customer-app-equity-tiles',
  templateUrl: './equity-tiles.component.html',
  styleUrls: ['./equity-tiles.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [EquityTileItemComponent]
})
export class EquityTilesComponent implements EquityPageComponentModel {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() data: any;
}
